<template>
  <transition name="scale-transition">
    <div v-show="showFab" class="fab-container px-4">
      <v-btn 
      :to="'/add-user/' + controllerId"
      x-large 
      class="w-100" color="primary">{{ $t('dodaj-uzytkownika') }}</v-btn>
    </div>
  </transition>
</template>

<script>
import ControllerCard from './../components/ControllerCard.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    showFab: false
  }),
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
  },
  mounted () {
    setTimeout(() => { this.showFab = true; }, 300);
  },
}
</script>